"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGenericReseller = void 0;
const config_1 = require("./config");
function isGenericReseller(catalogSlug) {
    return catalogSlug === config_1.envConfig.genericUrl || !catalogSlug;
}
exports.isGenericReseller = isGenericReseller;
